import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const DiscountContext = createContext();

export const useDiscount = () => {
  return useContext(DiscountContext);
};

export const DiscountProvider = ({ children }) => {
  const [discountType, setDiscountType] = useState(false);
  const [discountVal, setDiscountVal] = useState(0);
  const [discountRate, setDiscountRate] = useState(0);
  const [discountFlag, setDiscountFlag] = useState(false);
  const [openDiscountbox, setOpenDiscountbox] = useState(false);

  const handleDiscountTypeChange = useCallback(() => {
    setDiscountType((current) => !current);
  }, []);

  const handleDisountBoxOpen = useCallback(() => {
    setOpenDiscountbox(true);
  }, []);

  const handleDisountBoxClose = useCallback(() => {
    setOpenDiscountbox(false);
  }, []);

  const calculateDiscount = useCallback(
    (subTotal) => {
      let discountValue = parseFloat(discountVal);
      setDiscountRate(discountVal);
      if (discountType) {
        discountValue = (discountVal / 100) * subTotal;
      }
      setDiscountVal(discountValue);
    },
    [discountVal, discountType]
  );

  const handleAddDiscount = useCallback(
    (subTotal) => {
      // Perform actions with the discount value and type
      setDiscountFlag(true);
      calculateDiscount(subTotal);

      // Close the modal after handling the discount
      handleDisountBoxClose();
    },
    [calculateDiscount, handleDisountBoxClose]
  );

  const clearDiscount = useCallback(() => {
    setDiscountFlag(false);
    setDiscountVal(null);
    setDiscountType(false);
  }, []);

  const value = useMemo(
    () => ({
      discountType,
      setDiscountType,
      discountVal,
      setDiscountVal,
      discountFlag,
      setDiscountFlag,
      openDiscountbox,
      setOpenDiscountbox,
      handleDiscountTypeChange,
      handleDisountBoxOpen,
      handleDisountBoxClose,
      handleAddDiscount,
      calculateDiscount,
      clearDiscount,
      discountRate,
      setDiscountRate,
    }),
    [
      discountType,
      discountVal,
      discountFlag,
      openDiscountbox,
      handleDiscountTypeChange,
      handleDisountBoxOpen,
      handleDisountBoxClose,
      handleAddDiscount,
      calculateDiscount,
      clearDiscount,
      discountRate,
    ]
  );

  return (
    <DiscountContext.Provider value={value}>
      {children}
    </DiscountContext.Provider>
  );
};
